import { Box, Container, Center, Heading, Stack, forwardRef } from '@chakra-ui/react';
import React from 'react';
import { TFunction } from 'i18next';
import FreePlan from '@/components/PricingPlan/FreePlan';
import EnterprisePlan from '@/components/PricingPlan/DeveloperPlan';

interface PricingProps {
  t: TFunction;
  ref: React.RefObject<HTMLDivElement>;
  language: 'en' | 'jp';
}

const Pricing: React.VFC<PricingProps> = forwardRef(({ t, language }, ref) => {
  return (
    <Box as="section" bg="teal.500" pb="8">
      <Box
        bg="blue.500"
        h="70px"
        mt="-35px"
        sx={{ transformOrigin: '100% 0', transform: 'skewY(-1deg)' }}
      />
      <Box ref={ref} as="section" bg="blue.500" py="50px" scrollSnapAlign="start">
        <Container h="100%" maxW="container.xl">
          <Center mb="12">
            <Heading as="h3" color="white" size="2xl">
              {t('pricing')}
            </Heading>
          </Center>
          <Stack
            align="center"
            direction={['column', 'column', 'row']}
            justify="center"
            spacing="8">
            <FreePlan language={language} t={t} />
            <EnterprisePlan language={language} t={t} />
          </Stack>
        </Container>
      </Box>
    </Box>
  );
});

export default Pricing;
